/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {respondToInactivityNudge} from '../api'

export const useMutationRespondToInactivityNudge = createReactQueryMutationHook('respondToInactivityNudge', respondToInactivityNudge)
